

<template>
    <a v-if="item.isbottle != 3" class="ui autoship-link" v-on:click="gotoAutoshipPage()">
        <img class="ui image tiny" src="../assets/autoship_logo-2.png" />
        <span class="price">{{getAutoshipPrice(item)}} &euro;</span>
    </a>
</template>

<script>

export default {
    props: ['item', 'index'],
    data() {
      return {
      }
    },
    computed: {
        goods() {
        //loaded from parent
        return this.$store.state.goodStore.topgoods
        },
        cart() {
        return this.$store.state.cartStore.activeCart
        },
        cartItems() {
            return this.$store.state.cartStore.items
        }
    },
    methods: {
        checkIfInCart(item){
            if(this.$store.state.cartStore.items.length > 0 && this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id }).length > 0) return true;
            else return false;
        },
        convertCartToAutoship(){
          //add autoship params to cart and go to edit page
          this.$store.dispatch('convertCartToAutoship', this.cart).then((response) => {

              this.$router.push({
                  name: 'autoship-edit',
                  params: {
                    id:response.data.cart.id
                  }

              });

          }).catch((error) => {
              console.error('Cart was not converted, error: ' + error)
          });

        },
        getAutoshipPrice(item) {
            if (this.checkIfInCart(item)) {
                return item.autoship_price;
            } else {
                if (this.$store.state.categoryStore.selectedCategory.categoryLink == 'vairuma') {
                    return item.autoship_best_price;
                } else {
                    return item.autoship_price;
                }
            }
        },
        gotoAutoshipPage() {
            if (!this.checkIfInCart(this.item)) {
                var updatedItem = {
                    order: 1,
                    good_id: this.item.id
                };
                this.$store.dispatch("addCartItem", [this.cart.id, updatedItem])
                .then(response => {
                    this.$router.push({name: 'autoship'});
                    return;
                }).catch(error => {
                    console.error("Cart was not loaded at GoodsPage. With error: ", error);
                    this.$router.push({name: 'autoship'});
                    return;
                });
            }
            this.convertCartToAutoship();
        }
    }
}

</script>
<style>
.pa-tag-wrapper {
    display: flex;
    flex-flow: row wrap;
    flex-shrink: 0;
    flex-grow: 0;
    align-items: flex-end;
    justify-content: space-between;
}

.pa-tag-wrapper .label {
    flex-shrink: 0;
}

.autoship-link {
    color: #212121;
    font-weight: bold;
    font-size: 1.2em;
    cursor: pointer;
}
.autoship-link img {
    width: 55px !important;
    display: inline !important;
    margin-right: 0 !important;
    margin-bottom: 4px;
}

.autoship-link .price {
    margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// AutoShip.vue?6356f604